import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { RouteGroup } from '@/modules/core/app/constants/api.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${RouteGroup.RELATIONSHIPS}/:relation/:id`,
      name: Module.RELATIONSHIP,
      component: () =>
        import(/* webpackChunkName: "relationship-page" */ './pages/RelationshipPage.vue'),
      props: true,
    },
  ],
  Module.RELATIONSHIP
);
